<template>
  <div>
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li>
          <nuxt-link :to="localePath('office-products')">
            {{
            $t("page.products")
            }}
          </nuxt-link>
        </li>
        <li>
          <nuxt-link :to="localePath('office-products-glass')">
            {{
            $t("page.glass")
            }}
          </nuxt-link>
        </li>
        <li>
          <nuxt-link :to="localePath('office-products-glass-')">
            {{
            $t("page.hole_drilling")
            }}
          </nuxt-link>
        </li>

        <li class="is-active">
          <a aria-current="page">{{ $t('form.create') }}</a>
        </li>
      </ul>
    </nav>

    <form @submit.prevent="onSubmit" style="width: 100%;">
      <div class="columns">
        <div class="column">
          <field-input
            :value.sync="min_diameter"
            name="min_diameter"
            required
            type="number"
            :label="`${$t('form.min_diameter')}:`"
            :vvas="$t('form.min_diameter')"
            unit="mm"
          />
        </div>
        <div class="column">
          <field-input
            :value.sync="max_diameter"
            name="max_diameter"
            required
            type="number"
            :label="`${$t('form.max_diameter')}:`"
            :vvas="$t('form.max_diameter')"
            unit="mm"
          />
        </div>
      </div>

      <div class="field m-t-5">
        <div class="control is-clearfix">
          <button
            class="button is-primary is-pulled-right"
            :class="{ 'is-loading': formLoading }"
          >{{ $t("form.submit") }}</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      min_diameter: null,
      max_diameter: null,
      formLoading: false
    };
  },

  methods: {
    async onSubmit() {
      const validation = await this.$validator.validateAll();
      if (!validation) return;

      this.formLoading = true;

      const { min_diameter, max_diameter } = this;

      try {
        const { data } = await this.$api.createHoleDrilling({
          min_diameter,
          max_diameter
        });

        this.$store.commit("glass/settings/hole_drilling/ADD_ITEM", data);

        this.$router.push(this.localePath("office-products-glass-hole-drilling"));
      } catch (e) {
        console.log(e);
        this.handleFormError(e.response.data);
      }

      this.formLoading = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/nuxt/pages/office/products/glass/hole-drilling/create.vue